<script>
    import {PRConnect} from "@projectroom/ui-lib";
    import {onDestroy, onMount} from 'svelte';
    import axios from "axios";

    export let imageUploadRef;
    export let bot;
    export let scenario;
    export let charAction;

    let imageChoicePopupFlag = false;
    let imageLoadingPopupFlag = false;
    let charActionImagePopup;
    let spinnerFlag = true;
    let imageEditMode = false;
    let imageEditPopupFlag = false;
    let charImageSize = 100;

    onMount(() => {
        if (scenario) {
            charAction = bot.defaultChar.getCharAction(scenario.charAction);
        }
    });

    export const clickCharActionChange = (target) => {
        charAction = target ? target : bot.defaultChar.getCharAction(scenario.charAction);
        imageEditPopupFlag = true;
        PRConnect.send("/api/Message/getCharImageContent", {id:charAction.id}, data => {
            if( data.header.status === "success") {
                const src = data.result.imageOrgContent;
                const $imageLayer = jQuery(charActionImagePopup);
                $imageLayer.attr("src", `${src}`);
                $imageLayer.css(JSON.parse(data.result.imageCss));
                const {width} = JSON.parse(data.result.imageCss);
                changeImageSize(width.replace("%", ""));
            }
        });
    }

    export const deleteScenarioCharAction = () => {
        // 단순히 스토리에서 동작이미지 선택안하는 용도로 사용됨
        scenario.deleteCharAction();
    }

    export const onImageFileUpload = (e, scenario) => {
        let image = e.target.files[0];
        const key = `${bot.bot2DChar.botId}/${bot.bot2DChar.charId}/bot-images/${image.name}`;
        const type = image.type;
        imageChoicePopupFlag = false;
        imageLoadingPopupFlag = true;
        PRConnect.send("/api/File/uploadPresignedUrl", {key, type}, data => {
            axios.put(data.result, image, {headers: {"Content-Type": type}})
            .then( response =>{
                bot.defaultChar.addCharAction(image.name, scenario);
                imageLoadingPopupFlag = false;
            });
        });
		imageUploadRef.value = null;  
    }
    
    export const clickImageChoicePopup = () => {
		if (!bot.isAuthority("imageCnt", bot.getCharActionListSize() + 1)) {
			return false;
		}
        imageChoicePopupFlag = true;
    }

    const clickChangeImage = (e) => {
        charAction.changeImageCss({width: `${charImageSize}%`});
        closeImageEditPopup();
    }

    const closeImageEditPopup = () => {
        imageEditMode = false;
        imageEditPopupFlag = false;
    }

    const clickDeleteImage = () => {
        bot.defaultChar.deleteCharAction(charAction);
        imageEditPopupFlag = false;
    }

    const changeImageSize = (size) => {
        charImageSize = size;
        jQuery(charActionImagePopup).css("width", `${charImageSize}%`);
    }

    const clickImageReSelect = () => {
        imageEditPopupFlag = false;
        imageUploadRef.click();
    }

</script>

<div class="image-choice-popup" class:show={imageChoicePopupFlag} on:click={()=> imageChoicePopupFlag = false}>
    <div class="popup-layer loading" on:click|stopPropagation>
        <div class="bring-image">
            <div class="image-upload"><img src="/static/images/upload-icon-big.svg" loading="lazy" alt="" class="image-151">
                <div>
                    <a href="#" class="image-upload-button w-button" on:click={()=> imageUploadRef.click()}>캐릭터 이미지 파일 가져오기</a>
                </div>
            </div>
            <div class="text-block-108">최대 크기 : 8MB, 권장사이즈 : 1000px*1000px<br>정방형 이미지를 권장합니다.</div>
        </div>
    </div>
</div>
<div class="image-loading-popup2" class:show={imageLoadingPopupFlag}>
    <div class="popup-layer loading">
        <div class="bring-image">
            <div class="spinner"></div>
            <div>이미지가 업로드중입니다.</div>
        </div>
    </div>
</div>
<div class="image-choice-popup2" class:show={imageEditPopupFlag} on:click={()=> imageEditPopupFlag = false}>
    <div class="image-popup-layer" on:click|stopPropagation>
        <div class="image-layer">
            <img bind:this={charActionImagePopup} class:resize-border={imageEditMode}>
        </div>
        {#if !imageEditMode}
        <div class="popup-button2">
            {#if scenario}
            <div class="image-reselection-btn w-button" on:click={clickImageReSelect}>
                <img src="/static/images/upload-icon_1.svg">이미지 변경하기
            </div>
            {/if}
            <div class="image-scale-btn w-button" on:click={()=>imageEditMode = true}>
                <img src="/static/images/scale-icon.svg"/>크기 조정하기
            </div>
            <div class="image-delete-btn w-button" on:click={clickDeleteImage}>
                <img src="/static/images/a-delete-icon.svg" />이미지 삭제하기
            </div>
        </div>
        {:else}
        <div class="modify">
            <div class="tab-sub-text">캐릭터 크기값 조정</div>
            <input type="range" min="1" max="100" bind:value={charImageSize} class="slider" id="myRange" on:change={(e)=> {changeImageSize(e.target.value)}}>
            <div class="size-text">{charImageSize}%</div>
        </div>
        <div class="popup-button">
            <a href="#" class="close-button w-button" on:click={()=>imageEditMode = false}>취소</a>
            <a href="#" class="quit-button w-button" on:click={clickChangeImage}>적용</a>
        </div>
        {/if}
        <div class="x-button pointer" on:click={()=> imageEditPopupFlag = false}></div>
    </div>
</div>
<style>
    @keyframes spinner {
        to {
            transform: rotate(360deg);
        }
    }

    .spinner:before {
        position: absolute;
        left: 53px;
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 40%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        border-radius: 50%;
        border-top: 2px solid #F7528A;
        border-right: 2px solid transparent;
        animation: spinner .7s linear infinite;
        animation-iteration-count: 3;
    }

    .image-delete-btn {
        width: 100%;
        height: 40px;
        color: #fff;
        text-align: center;
        background-color: #F27777;
        background-position: 20%;
        background-repeat: no-repeat;
        background-size: auto;
        border: 1px #ff558d;
        border-radius: 10px;
        margin-top: 0;
        margin-bottom: 10px;
        margin-right: 0;
        padding-left: 15px;
        font-family: "Noto sans kr 400", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
    }

    .image-layer {
        display: flex;
        justify-content: center;
        align-items: center;
        background-repeat: no-repeat;
        width: 316px;
        height: 344px;
        border: 1px solid #e1dddd;
        margin-top: 14px;
    }

	.image-layer img {
		max-width: 100%;
		max-height: 100%;
	}

    .resize-border {
        border: 2px dashed #dddddd;
    }

    .tab-sub-text {
        margin-bottom: 10px;
        margin-left: 8px;
    }

    .slider {
        width: 80%;
        vertical-align: text-bottom;
    }

    .size-text {
        display: inline-block;
        margin-left: 3px;
    }

    .modify {
        width: 69%;
    }

    .popup-button {
        margin-top: 10px;
    }

    .image-choice-popup {
        position: fixed;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .image-loading-popup2 {
        position: fixed;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .image-choice-popup2 {
        position: fixed;
    }
    .image-scale-btn {
        background-image:none;
        display: flex;
        justify-content: center;
    }
    .w-button img {
        margin-right: 8px;
        width: 18px;
        margin-botton: 3px;
    }
    .image-reselection-btn {
        background-image: none;
    }
    .image-popup-layer {
        height: 540px;
    }
	.text-block-108 {
		font-size: 14px;
		margin-right: none;
		color: #aaa;
    	font-family: "Noto sans kr 400", sans-serif;
		width: auto;
	}
</style>